/**
 * START A CREW (phone) — `design/GT Mobile Crew.dc.html`,
 * `data-screen-label="Start a crew"`.
 *
 * The card itself is shared with the desktop tree; this file is the phone
 * column's measurements and nothing else. See `components/StartCrewCard.tsx`
 * for why the split is metrics rather than two copies.
 */

import { StartCrewCard } from '../components/StartCrewCard.tsx';

export default function StartCrew(): JSX.Element {
  return (
    <StartCrewCard
      m={{
        pad: '20px 14px',
        width: '100%',
        cardPad: '20px 16px 18px',
        gap: '15px',
        labelFs: '8.5px',
        railNumFs: '7px',
        railLabelFs: '8px',
      }}
    />
  );
}
